import { useMutation } from '@tanstack/react-query';

/* keys */
import { userQueryKeys } from './queries.keys';
import { cartQueryKeys } from '../cart/queries.keys';

/* Apis */
import { cart, user } from '@api/apis';

/* utils */
import { Logger } from '@utils/logger';

/* App Navigation Store */
import { updateAppNotification } from '@store/client/store.notifications';

/* Libs */
import { queryClient } from '@integrations/reactquery';
import Chat from '@integrations/gladly/Chat/Gladly.methods';

export default function useUserMutationLogout() {
  /* This hooks gives us chat specific items to use */

  return useMutation({
    mutationFn: async () => {
      // const auth = queryClient.getQueryData(userQueryKeys.auth);
      // @ts-ignore
      const response = await user.logout();
      // const response = await fetch(`/api/_nextassets_/logout?auth_token=${(auth as any).authToken}`);
      /* clear cache prior to cart call */
      queryClient.setQueryData(['auth'], {});

      const cartResponse = await cart.find({ breakdown: true });

      if (response.status === 500) {
        throw new Error('Logout Server Error');
      }

      return cartResponse;
    },
    /* Reset cart and chat */
    onSuccess: data => {
      const { cart: cartResponse = {} } = data?.data ?? {};
      queryClient.setQueryData(cartQueryKeys.all, { ...cartResponse });
      queryClient.setQueryData(userQueryKeys.all, {});

      Chat.logout();
      Chat.start();
    },

    onError: error => {
      const message = error?.message ?? 'We coud not log you out. Please try again later.';
      updateAppNotification({ error_title: 'Logout Error', errors: message });

      Logger('useUserMutationLogout')(error as Error);
    },
  });
}
